import { Link, useLocation } from 'react-router-dom';
import { NavLink } from '@mantine/core';

import classes from './NavItem.module.css';
import { ReactElement } from 'react';

type NavItemProps = {
  label: string;
  link: string;
  Icon: ReactElement;
  accessibleLabel?: string;
};

const NavItem = ({ label, link, Icon, accessibleLabel }: NavItemProps) => {
  const location = useLocation();
  const isActive = !!(location.pathname && location.pathname.startsWith(link));

  return (
    <NavLink
      label={label}
      aria-label={accessibleLabel || label || undefined}
      leftSection={Icon}
      component={Link}
      to={link}
      active={isActive}
      classNames={{
        root: classes.root,
        label: classes.label,
      }}
      styles={
        label === ''
          ? {
              section: { marginLeft: '0', marginRight: '0' },
              body: { display: 'none' },
              root: {
                width: '30px',
                // height: '28px',
                margin: 0,
                padding: 0,
                justifyContent: 'center',
              },
            }
          : {}
      }
    />
  );
};

export default NavItem;
